// extracted by mini-css-extract-plugin
module.exports = {"durationHeader":"RequestList_durationHeader__3dMjlT3Ewbk-0r2BQEYa_7","sqlTimingsHeader":"RequestList_sqlTimingsHeader__WHGhgFPJ4kyc3g2CtQ1Dk"};